export default __webpack_public_path__ + "static/media/saifanlogo.7922525e.png";